<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h4>Award</h4>
      <vs-tooltip text="Add" color="primary">
        <vs-button
          type="border"
          color="primary"
          icon="add"
          @click="handleAddPopUp"
        />
      </vs-tooltip>
    </div>

    <div class="table-responsive">
      <table v-if="awardProps.length > 0" class="light_blue_table w-full">
        <tbody>
          <tr :key="indextr" v-for="(item, indextr) in awardProps">
            <td>
              <img
                v-if="item.picture"
                style="width: 40px; height: 40px"
                :src="item.picture"
              />
              <div v-else>No Picture Available</div>
            </td>
            <td>
              {{ item.year }}
            </td>
            <td>
              {{ item.award_name }}
            </td>

            <td>
              {{ item.award_description }}
            </td>
            <td class="text-right">
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-if="item.picture"
                    @click="preview(item.picture)"
                  >
                    Preview </vs-dropdown-item
                  ><vs-dropdown-item @click="handleedit(indextr)">
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="remove(indextr)">
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="awardProps.length == 0" class="text-center">
        No Award found
      </div>
    </div>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Add Award"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-model="award.year"
              v-validate="'required|min:4|max:4|numeric'"
              name="year"
              class="custom_Input"
              label="Year"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.year')" class="text-danger">{{
              errors.first("add.year")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="award-name"
              v-model="award.award_name"
              class="custom_Input"
              label="Award Name"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.award-name')" class="text-danger">{{
              errors.first("add.award-name")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-textarea
              class="mb-0"
              name="award-description"
              v-model="award.award_description"
              label="Award Description"
              style="width: 100%"
            />
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx">
            <div class="w-full">{{ previewImageName }}</div>
            <label class="block mb-4" for="myfile">Upload Certificate:</label>
            <FileUpload
              :platform_module_id="2"
              @changingImage="saveImage"
            ></FileUpload>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Edit Award"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required|min:4|max:4|numeric'"
              name="year"
              v-model="edit.year"
              class="custom_Input"
              label="Year"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.year')" class="text-danger">{{
              errors.first("edit.year")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="award-name"
              v-model="edit.award_name"
              class="custom_Input"
              label="Award Name"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.award-name')" class="text-danger">{{
              errors.first("edit.award-name")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-textarea
              name="award-description"
              v-model="edit.award_description"
              label="Award Description"
              style="width: 100%"
            />
          </vs-col>

          <vs-col
            :vs-xs="12"
            :vs-md="12"
            :vs-lg="12"
            class="p-2 centerx flex-wrap"
            vs-type="flex"
            vs-justify="space-between"
          >
            <div class="w-full">
              <label for="myfile">Uploaded Certificate:</label>
              <FileUpload
                :platform_module_id="2"
                @changingImage="saveImageedit"
                :image="edit.picture"
              ></FileUpload>
            </div>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdateAvailiblity"
          >Save</vs-button
        >
        <vs-button type="border" color="danger" @click="editpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Preview"
      :active.sync="previewPopup"
    >
      <vs-row>
        <img :src="file_url" />
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import FileUpload from '@/views/pages/v1/user_profile/components/profile/personal_information/certificateFile.vue'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker'
import { TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'email',
  components: {
    flatPickr,
    vSelect,
    Datepicker,
    FileUpload
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    awardProps: {
      required: true,
      type: Array,
      default: () => []
    },
    havePermission: {
      default: false
    },
    teacherPersonalDetails: {
      required: false,
      type: Object,
      default: () => {}
    }
  },
  watch: {
    awardProps: {
      deep: true,
      immediate: true,
      handler () {
        this.awardAvailability = this._.cloneDeep(this.awardProps)
      }
    }
  },
  data () {
    return {
      file_url: '',
      previewPopup: false,
      previewImageName: '',
      awardAvailability: [],
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      award: {
        award_description: null,
        award_name: null,
        picture: null,
        year: null
      },
      edit: {
        award_description: null,
        award_name: null,
        picture: null,
        year: null
      },
      editIndex: null,
      deleteindex: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      imageDataUrl: null,
      fileName: ''
    }
  },
  methods: {
    handleAddPopUp () {
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addpopup = true
    },
    preview (data) {
      console.log(data)
      this.previewPopup = true
      this.file_url = data
    },
    saveImage (url) {
      this.award.picture = url
    },
    saveImageedit (url) {
      this.edit.picture = url
    },
    handlePhonedefault (index) {
      this.awardAvailability.map((item) => {
        item.default = 0
      })
      this.awardAvailability[index].default = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = this.award
          this.awardAvailability.push(payload)
          this.handleAwardsave()
        }
      })
    },
    handleedit (index) {
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editpopup = true

      this.edit = this.awardAvailability[index]
      this.editIndex = index
    },
    handleUpdateAvailiblity () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.awardAvailability[this.editIndex] = this.edit
        }
        this.handleAwardsave()
      })
    },
    handleDelete () {
      this.awardAvailability.splice(this.deleteindex, 1)
      this.handleAwardsave()
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    uploadImg (e, num, type) {
      const file = e.target.files[0]
      const fileSize = e.target.files[0].size / 1024 / 1024
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      if (fileSize < 5) {
        // this.dialogVisible = true
        //
        if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG|PDF)$/.test(e.target.value)) {
          alert('File Should be must this (.gif,jpeg,jpg,png,bmp,pdf) type')
          return false
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = new Blob([e.target.result])
            // fd.append('upload_path', 'FeedWall')
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        //
      } else {
        this.option.img = ''

        this.dialogVisible = false
        this.$vs.notify({
          title: 'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      if (type === 'edit') {
        this.previewImageName = file.name
      }
    },
    async handleAwardsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            awards: this.awardAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )

        this.addpopup = false
        this.award = {
          award_description: null,
          award_name: null,
          picture: null,
          year: null
        }
        this.editpopup = false

        this.deletepopup = false

        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
    